"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createNewEvent(eventName, bubbles, cancelable) {
    let event;
    if (typeof (Event) === 'function') {
        event = new Event(eventName);
    }
    else {
        event = document.createEvent('Event');
        event.initEvent(eventName, bubbles, cancelable);
    }
    return event;
}
exports.default = createNewEvent;
